// extracted by mini-css-extract-plugin
export default {"title":"NewsnEvents_title__J4KlE"};